// @ts-check
import { sortByOptions } from 'components/Search/Results/QuickFilters/sortByOptions';

// A sort is carried as the raw index field it orders on, which is what a review
// row would otherwise show. The main-search list is the right one on both paths:
// the org profile only ever shows a sort to say it is dropping it, and the org
// list gives a different label to values the two share.

/**
 * @param {string} value
 * @returns {string}
 */
export const sortByLabel = value =>
  sortByOptions.find(option => option.value === value)?.label ?? value;

/**
 * Review values arrive either as plain strings or as `{ text }` chips, depending
 * on which branch built the row.
 *
 * @param {{ text: string } | string} value
 * @returns {{ text: string } | string}
 */
export const labelledSortByValue = value =>
  typeof value === 'string'
    ? sortByLabel(value)
    : { ...value, text: sortByLabel(value.text) };

/**
 * @param {{ key: string, values: any[] }[]} rows
 * @returns {{ key: string, values: any[] }[]}
 */
export const withLabelledSortBy = rows =>
  rows.map(row =>
    row.key === 'sortBy'
      ? { ...row, values: row.values.map(labelledSortByValue) }
      : row
  );
